var path = '/modules/tickets/templates/components/al-ticket-template-preview/component.tpl.html';
var html = "<iframe id=\"ticket-template-preview-iframe\" style=\"width:{{vm.previewData.pdf_options['page-width']}};height: {{vm.previewData.pdf_options['page-height']}};border:0;\"></iframe>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/tickets/templates/components/al-ticket-template-preview/component.tpl.html
// module id = 2164
// module chunks = 1